import {AbstractControl, ValidatorFn} from '@angular/forms';

export function allowedSelectionValidator(allowedSelection: string[]): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    if (allowedSelection == null || allowedSelection.indexOf(control.value) === -1) {
      return {'allowed-selection': {value: allowedSelection}};
    } else {
      return null;
    }
  };
}
